<script>
    import { fade } from "svelte/transition"
    import Block from "./Block.svelte";
    import SectionControls from "./SectionControls.svelte";
    import {sections} from '../stores'
    import {newBlock} from '../constants'
import Row from "./Row.svelte";
import { afterUpdate } from "svelte";

    export let section;
    export let index;

    let edit = false;

    function hideControls() {
        edit = false;
    }

    function addBlock(sectionIndex, typeString, objectIdString) {
        switch (typeString) {
            case "text":
                $sections[sectionIndex].blocks = [
                    ...$sections[sectionIndex].blocks,
                    newBlock,
                ];
                break;
            case "donationbox":
                $sections[sectionIndex].blocks = [
                    ...$sections[sectionIndex].blocks,
                    {
                        contentType: "donationbox",
                        content: objectIdString,
                    },
                ];
                break;

            default:
                break;
        }
    }
</script>

<section class="df-section df-section-{section.id}" in:fade>
    {#if edit}
        <SectionControls {hideControls} {index} />
    {:else}
        <div class="df-section-controls">
            <div
                class="df-section-control-btn shadow"
                on:click={() => (edit = true)}
            >
                Edit
            </div>
        </div>
    {/if}
    <div class="container">
        {#if section.rows}
            {#each section.rows as row, rowIndex}
                <Row {row} sectionIndex={index} {rowIndex} />
            {/each}
        {/if}

        <!-- {#if section.blocks}
            {#each section.blocks as block}
                <Block {block} {addBlock} sectionIndex={index} />
            {/each}
        {/if} -->
    </div>
</section>

<style>
    section {
        min-height: 200px;
        border: 2px solid #ffffff;
        position: relative;
    }
    .df-section-controls {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
    }
    section .df-section-controls {
        visibility: hidden;
    }
    section:hover .df-section-controls {
        visibility: visible;
    }
    .df-section-control-btn {
        padding: 10px 20px;
        border-radius: 7px;
    }
    .df-section {
        display: flex;
        align-items: center;
    }
    section:hover {
        border: 2px solid #e8e8e8;
    }
</style>
